module.exports = __webpack_public_path__ + "favicon-144-b9f8b6655570d497e6083d6b53354070.bundle.png";